import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LangContext";
import { SectionHead, Reveal } from "./Reveal";

export const Journal = () => {
  const { t } = useLang();
  return (
    <section id="journal" data-testid="journal-section" className="px-6 md:px-12 py-28 md:py-40">
      <SectionHead id="journal" over={t.journal.over} title={t.journal.title} />
      <ul className="mt-16 border-t border-line">
        {t.journal.posts.map((p, i) => (
          <Reveal key={p.t} delay={i * 0.06}>
            <li className="group grid grid-cols-12 gap-4 items-center py-8 md:py-10 border-b border-line" data-testid={`journal-post-${i}`}>
              <span className="col-span-12 md:col-span-2 font-mono text-xs tracking-[0.2em] uppercase text-gold">{p.c}</span>
              <h3 className="col-span-10 md:col-span-7 font-display text-2xl md:text-4xl leading-tight transition-transform duration-500 group-hover:translate-x-3">{p.t}</h3>
              <span className="hidden md:block md:col-span-2 font-mono text-[11px] tracking-[0.16em] uppercase text-stone">{t.journal.badge}</span>
              <ArrowUpRight className="col-span-2 md:col-span-1 justify-self-end text-stone group-hover:text-gold group-hover:rotate-45 transition-[transform,color] duration-500" />
              <span className="md:hidden col-span-12 font-mono text-[11px] tracking-[0.16em] uppercase text-stone">{t.journal.badge}</span>
            </li>
          </Reveal>
        ))}
      </ul>
    </section>
  );
};
